import React from 'react';
import {useSelector} from "react-redux";
import {getRowNumber} from "mindsets-js-sdk";

import Row from './Row';

export default function () {
    const current = useSelector(state => state['responses_current']);
    const limit = useSelector(state => state['responses_limit']);
    const items = useSelector(state => state.responses);

    return (
        <div className="table-responsive">
            <table className="table table-bordered table-hover">
                <thead>
                <tr className="text-center">
                    <th scope="col">No</th>
                    <th scope="col">Response ID</th>
                    <th scope="col">Answer</th>
                    <td>Manual score</td>
                    <td>AI score</td>
                    <td>AI Reasoning</td>
                </tr>
                </thead>
                <tbody>
                {items.map((item, index) => {
                    return <Row
                        key={item.id}
                        item={item}
                        row_number={getRowNumber(index, current, limit)}
                    />;
                })}
                </tbody>
            </table>
        </div>
    );
}
